// src/components/orders/OrderOriginBadge/OrderOriginBadge.jsx
import React from 'react';
import { Globe } from 'lucide-react';
import { useLocalization } from '../../../contexts/LocalizationContext';
import styles from './OrderOriginBadge.module.css';

// Order origin with its icon, label and paid/organic type
const OrderOriginBadge = ({ origin }) => {
  const { t } = useLocalization();
  if (!origin) return null;

  const typeLabel = origin.type === 'paid' ? t('ecomOrders.paid') : origin.type === 'organic' ? t('ecomOrders.organic') : null;

  return (
    <span className={styles.origin}>
      {origin.iconUrl
        ? <img src={origin.iconUrl} alt={origin.label} className={styles.originIcon} />
        : <Globe size={16} className={styles.originFallbackIcon} />}
      <span className={styles.originLabel}>{origin.label}</span>
      {typeLabel && (
        <span className={`${styles.typeBadge} ${origin.type === 'paid' ? styles.typePaid : styles.typeOrganic}`}>
          {typeLabel}
        </span>
      )}
    </span>
  );
};

export default OrderOriginBadge;
